// extracted by mini-css-extract-plugin
module.exports = {"mapRoot":"MarketplaceMap_mapRoot__ST_O8"};